import { AxiosResponse } from "axios";

import { apiPublicAxios } from "../../axios";
import { SECURE_DATA_REQUEST } from "../../resources";

export interface ISubmitRequestPayload {
  submitted: boolean;
  data: string;
}

export interface ISubmitRequestResponse {
  isSuccess: boolean;
  message?: string;
}

export interface ISecureDataResponse {
  data: string;
  isSuccess: boolean;
}

export interface ISecureDataPageContent {
  logo?: string;
  title?: string;
  onLinkUsedMessage?: string;
  isTextData: boolean;
}

export const submitRequest = (
  requestId: string,
  payload: ISubmitRequestPayload
): Promise<AxiosResponse<ISubmitRequestResponse>> => {
  return apiPublicAxios.post<ISubmitRequestResponse>(
    `${SECURE_DATA_REQUEST}/submitRequest/${requestId}`,
    payload
  );
};

export const getSecureRequestLinkPageContent = (
  code: string
): Promise<AxiosResponse<ISecureDataPageContent>> => {
  return apiPublicAxios.get<ISecureDataPageContent>(
    `${SECURE_DATA_REQUEST}/pageContent`,
    {
      params: { code },
    }
  );
};
